import { z } from "zod";

const UpdateUserBrandSchema = z.object({
  userId: z.number().int().positive(),
  brandId: z.number().int().positive(),
  roleId: z.number().int().positive(),
  isActive: z.boolean(),
  customPermissions: z.array(z.number().int().positive()).optional().nullable(),
});

export type UpdateUserBrandDTOShape = z.infer<typeof UpdateUserBrandSchema>;

export class UpdateUserBrandDTO {
  readonly userId!: number;
  readonly brandId!: number;
  readonly roleId!: number;
  readonly isActive!: boolean;
  readonly customPermissions?: number[] | null;

  constructor(data: UpdateUserBrandDTOShape) {
    const validated = UpdateUserBrandSchema.parse(data);
    Object.assign(this, validated);
  }

  static validate(data: unknown) {
    return UpdateUserBrandSchema.safeParse(data);
  }
}
